import type { AuthConfig } from '../types/api';
import { fetchWithTimeout } from './http';

const BASE = import.meta.env.VITE_API_BASE_URL ?? '';

/**
 * The one call the app makes before it knows whether it needs a token.
 *
 * Unauthenticated by necessity rather than by oversight: it is what tells the caller
 * whether authentication is required at all.
 */
export async function fetchAuthConfig(): Promise<AuthConfig> {
  const res = await fetchWithTimeout(`${BASE}/api/v1/auth/config`);
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json() as Promise<AuthConfig>;
}
